<template>
  <div class="container-fluid">
    <div class="card-body">
      <b-row align-h="end">
        <button
          class="btn btn-primary font-weight-bold mr-2"
          style="height: 38px"
          ref="import-orcamento-button"
          v-if="
            store.formNatureza.cfop &&
            store.formNatureza.cfop !== '5929' &&
            checkTpNF == 1
          "
          v-b-tooltip.top="'Somente irá importar com status: Autorizado'"
          @click="buscarOrcamentos"
        >
          Importar Orçamento
        </button>
        <button
          class="btn btn-primary font-weight-bold mr-2"
          style="height: 38px"
          ref="import-orcamento-button"
          v-if="
            store.formNatureza.cfop &&
            store.formNatureza.cfop !== '5929' &&
            checkTpNF == 1
          "
          v-b-tooltip.top="'Somente irá importar com status: Autorizado'"
          @click="buscarPedidos"
        >
          Importar Pedido
        </button>
        <button
          class="btn btn-primary font-weight-bold"
          style="height: 38px"
          v-if="store.formNatureza.cfop === '5929' && checkTpNF == 1"
          v-b-modal.importarNfce
          ref="import-nfce-button"
        >
          Importar NFce
        </button>
        <button
          class="btn btn-primary font-weight-bold mr-2"
          style="height: 38px"
          ref="import-orcamento-button"
          v-if="
            store.formNatureza.cfop &&
            store.formNatureza.cfop !== '5929' &&
            checkTpNF == 1
          "
          v-b-tooltip.top="
            'Somente irá importar as OS: Autorizadas, Finalizadas, Em andamento e Serviço concluído'
          "
          @click="buscarOS"
        >
          Importar OS
        </button>
        <b-col md="2">
          <div class="cardHeader">
            <b-form-checkbox
              name="nfe-saida"
              switch
              size="lg"
              v-model="checkTpNF"
            >
              NF-e de Saída
            </b-form-checkbox>
          </div>
        </b-col>
      </b-row>
      <b-card>
        <b-tabs
          pills
          :horizontal="windowWidth < 768"
          :vertical="windowWidth > 768"
          :nav-wrapper-class="windowWidth > 768 ? 'w-25' : 'w-100'"
          fill
        >
          <Natureza />
          <Cliente />
          <Produto />
          <Impostos />
          <Faturamento ref="faturamento" />
          <Transportador />
          <Intermediador />
        </b-tabs>
      </b-card>
      <div class="card-footer">
        <div class="row">
          <div class="col-lg-12" style="text-align: center">
            <div v-if="canSaveNfe">
              <div class="form mb-5">
                <button
                  v-if="store.currentTab !== 0"
                  class="btn btn-secondary font-weight-bold mr-2"
                  @click="handlePrevious"
                >
                  Anterior (F4)
                </button>
                <button
                  v-if="store.isUpdate && store.currentTab !== 6"
                  class="btn btn-primary font-weight-bold mr-4"
                  @click="handleNext"
                >
                  Proximo (F5)
                </button>
                <button
                  ref="submit_nova_nfe"
                  class="btn btn-primary font-weight-bold"
                  @click="salvarNFe"
                >
                  Salvar (F2)
                </button>
                <button
                  ref="submit_danfe"
                  class="btn btn-secondary font-weight-bold mx-2"
                  @click="salvarPreviaNFe"
                >
                  Visualizar Pré-Danfe (F3)
                </button>
                <button
                  v-b-modal.modalTransmitirNfe
                  class="btn btn-secondary font-weight-bold mx-2"
                >
                  Transmitir (F5)
                </button>
                <button
                  ref="submit_previa_nfe"
                  class="btn btn-clean font-weight-bold"
                  @click="confirmCancel('nfe')"
                >
                  Cancelar (F1)
                </button>
              </div>
            </div>
            <div v-else>
              <button
                :disabled="store.currentTab === 0"
                class="btn btn-secondary font-weight-bold mr-4"
                @click="handlePrevious"
              >
                Anterior (F4)
              </button>
              <button
                class="btn btn-primary font-weight-bold"
                @click="handleNext"
              >
                Proximo (F5)
              </button>
              <button
                ref="submit_previa_nfe"
                class="btn btn-clean font-weight-bold"
                @click="confirmCancel('nfe')"
              >
                Cancelar (F1)
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="modalTransmitirNfe" title="Transmissão" centered>
      <b-form class="form">
        <div
          class="d-flex flex-column mx-auto"
          style="gap: 0.5rem; width: 40rem"
        >
          <CheckBox label="Imprimir DANFE" v-model="printDanfe" />
          <CheckBox
            label="Enviar arquivo XML por e-mail"
            v-model="xmlToEmail"
            v-if="store.formCliente.email"
          />
          <CheckBox
            v-b-tooltip="checkNutsDigital()"
            :disabled="!canGenerateBoleto"
            label="Gerar boleto das parcelas"
            v-model="generateBoleto"
          />
          <CheckBox label="Imprimir Duplicata" v-model="printDuplicata" />
        </div>
      </b-form>
      <template #modal-footer="{ ok, cancel }">
        <b-button variant="primary" @click="transmitirNFe" ref="transmitir_nfe">
          Transmitir (F5)
        </b-button>
        <b-button @click="cancel()"> Cancelar </b-button>
      </template>
    </b-modal>

    <b-modal id="importarNfce" title="Importar NFce" centered>
      <b-form class="form">
        <b-col>
          <b-form-group label="NFCe" label-for="nfce">
            <VueSelect
              multiple
              ref="nfce"
              :filterable="false"
              :options="nfceToImport"
              v-model="selectedNFCe"
              @search="onSearchNFCe"
            >
              <template slot="no-options"> Informe o número da NFCe</template>
              <template slot="option" slot-scope="option">
                <div class="d-center">
                  {{ option.numero }}
                </div>
              </template>
              <template slot="selected-option" slot-scope="option">
                <div class="selected d-center">
                  {{ option.numero }}
                </div>
              </template>
            </VueSelect>
          </b-form-group>
        </b-col>
      </b-form>
      <template #modal-footer="{ ok, cancel }">
        <b-button variant="primary" @click="importarNFce" ref="importar_nfce">
          Importar
        </b-button>
        <b-button @click="cancel()"> Cancelar </b-button>
      </template>
    </b-modal>

    <b-modal id="importarOS" title="Importar OS" centered size="lg">
      <b-form class="form">
        <b-row align-h="center">
          <b-col>
            <b-form-group
              :key="keyToReRender"
              label="Selecione a(s) OS"
              label-for="os"
            >
              <VueSelect
                multiple
                ref="os"
                class="vs-pedido-clean"
                :filterable="false"
                :options="osToImport"
                v-model="selectedOS"
                @search="onSearchOS"
                :close-on-select="false"
              >
                <template slot="no-options"> Informe a OS</template>
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.numero }} - {{ option.cliente }}
                  </div>
                </template>
                <template slot="selected-option">
                  <span style="display: none"></span>
                </template>
              </VueSelect>
            </b-form-group>

            <div v-if="selectedOS && selectedOS.length > 0">
              <p class="mb-1" style="font-size: 0.85rem; color: #6c757d">
                {{ selectedOS.length }} OS selecionada(s) para importar:
              </p>
              <ul class="list-group">
                <li
                  v-for="(os, index) in selectedOS"
                  :key="os.id_ordem_servico"
                  class="list-group-item d-flex justify-content-between align-items-center py-2 px-3"
                  style="font-size: 0.9rem"
                >
                  <span>
                    <strong>#{{ os.numero }}</strong> — {{ os.cliente }}
                  </span>
                  <b-button
                    size="sm"
                    variant="outline-danger"
                    style="padding: 0.1rem 0.4rem; font-size: 0.75rem"
                    @click="
                      selectedOS = selectedOS.filter((_, i) => i !== index)
                    "
                  >
                    ✕
                  </b-button>
                </li>
              </ul>
            </div>
          </b-col>
        </b-row>
      </b-form>
      <template #modal-footer="{ ok, cancel }">
        <b-button variant="primary" @click="importarOS" ref="importar_os">
          Importar
        </b-button>
        <b-button
          @click="
            () => {
              cancel();
              selectedOS = null;
            }
          "
        >
          Cancelar
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="importarOrcamento"
      title="Importar Orçamento"
      centered
      size="lg"
    >
      <b-form class="form">
        <b-row align-h="center">
          <b-col>
            <b-form-group
              :key="keyToReRender"
              label="Selecione o(s) orçamento(s)"
            >
              <VueSelect
                multiple
                ref="orcamento"
                class="vs-pedido-clean"
                :filterable="false"
                :options="orcamentosToImport"
                v-model="selectedOcamentos"
                @search="onSearchOrcamento"
                :close-on-select="false"
              >
                <template slot="no-options"> Informe o orçamento</template>
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.numero }} - {{ option.cliente }}
                  </div>
                </template>
                <template slot="selected-option">
                  <span style="display: none"></span>
                </template>
              </VueSelect>
            </b-form-group>

            <div v-if="selectedOcamentos && selectedOcamentos.length > 0">
              <p class="mb-1" style="font-size: 0.85rem; color: #6c757d">
                {{ selectedOcamentos.length }} orçamento(s) selecionado(s) para
                importar:
              </p>
              <ul class="list-group">
                <li
                  v-for="(orc, index) in selectedOcamentos"
                  :key="orc.id_orcamento"
                  class="list-group-item d-flex justify-content-between align-items-center py-2 px-3"
                  style="font-size: 0.9rem"
                >
                  <span>
                    <strong>#{{ orc.numero }}</strong> — {{ orc.cliente }}
                  </span>
                  <b-button
                    size="sm"
                    variant="outline-danger"
                    style="padding: 0.1rem 0.4rem; font-size: 0.75rem"
                    @click="
                      selectedOcamentos = selectedOcamentos.filter(
                        (_, i) => i !== index
                      )
                    "
                  >
                    ✕
                  </b-button>
                </li>
              </ul>
            </div>
          </b-col>
        </b-row>
      </b-form>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="primary"
          @click="importarOrcamento"
          ref="importar_orcamento"
        >
          Importar
        </b-button>
        <b-button
          @click="
            () => {
              cancel();
              selectedOcamentos = null;
            }
          "
        >
          Cancelar
        </b-button>
      </template>
    </b-modal>

    <b-modal id="importarPedido" title="Importar Pedido" centered size="lg">
      <b-form class="form">
        <b-row align-h="center">
          <b-col>
            <b-form-group
              :key="keyToReRender"
              label="Selecione o(s) pedido(s)"
              label-for="pedido"
            >
              <VueSelect
                multiple
                ref="pedido"
                class="vs-pedido-clean"
                :filterable="false"
                :options="pedidosToImport"
                v-model="selectedPedidos"
                @search="onSearchPedido"
                :close-on-select="false"
              >
                <template slot="no-options"
                  >Busque pelo número do pedido</template
                >
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.numero }} - {{ option.cliente }}
                  </div>
                </template>
                <template slot="selected-option">
                  <span style="display: none"></span>
                </template>
              </VueSelect>
            </b-form-group>

            <div v-if="selectedPedidos && selectedPedidos.length > 0">
              <p class="mb-1" style="font-size: 0.85rem; color: #6c757d">
                {{ selectedPedidos.length }} pedido(s) selecionado(s) para
                importar:
              </p>
              <ul class="list-group">
                <li
                  v-for="(pedido, index) in selectedPedidos"
                  :key="pedido.id_pedido"
                  class="list-group-item d-flex justify-content-between align-items-center py-2 px-3"
                  style="font-size: 0.9rem"
                >
                  <span>
                    <strong>#{{ pedido.numero }}</strong> — {{ pedido.cliente }}
                  </span>
                  <b-button
                    size="sm"
                    variant="outline-danger"
                    style="padding: 0.1rem 0.4rem; font-size: 0.75rem"
                    @click="
                      selectedPedidos = selectedPedidos.filter(
                        (_, i) => i !== index
                      )
                    "
                  >
                    ✕
                  </b-button>
                </li>
              </ul>
            </div>
          </b-col>
        </b-row>
      </b-form>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="primary"
          @click="importarPedido"
          ref="importar_pedido"
        >
          Importar
        </b-button>
        <b-button
          @click="
            () => {
              cancel();
              selectedPedidos = null;
            }
          "
        >
          Cancelar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import "vue-select/dist/vue-select.css";
import { validationMixin } from "vuelidate";
import FormatMixin from "../../Application/mixins/FormatMixin";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import { mask } from "vue-the-mask";
import CheckBox from "../../../components/Form/Checkbox.vue";
import PagamentosMixin from "../../Pdv/mixins/PagamentosMixin";
import InstallmentsMixin from "../../Application/mixins/InstallmentsMixin";
import { TECLAS } from "../../Pdv/enums/Documento";
import Natureza from "./componentes/NaturezaTab.vue";
import Cliente from "./componentes/ClienteTab.vue";
import Produto from "./componentes/ProdutoTab.vue";
import Transportador from "./componentes/TransportadorTab.vue";
import Faturamento from "./componentes/FaturamentoTab.vue";
import Impostos from "./componentes/ImpostosTab.vue";
import { store } from "../storeNfe";
import Intermediador from "./componentes/Intermediador.vue";
import VueSelect from "vue-select";
import _ from "lodash";
import swal from "sweetalert";
import { isSicoobApiAtiva } from "@/core/utils/sicoob";

export default {
  name: "app-nfe-form",
  props: {
    notaCompra: {
      type: Object,
      default: () => {},
    },
  },
  directives: {
    mask,
  },
  data() {
    return {
      store,
      windowWidth: window.innerWidth,
      pagamentoImportacaoBloqueado: false,
      pedidosToImport: [],
      selectedPedidos: null,
      openTransmitirNFeModal: false,
      selectedOcamentos: null,
      formImpostos: {},
      formProduto: {},
      nfceNumber: null,
      orcamentosToImport: null,
      formTransportador: {},
      formFaturamento: {},
      formToSendToImpostoApi: {},
      productOfTradeCollection: [],
      printDanfe: true,
      xmlToEmail: false,
      generateBoleto: false,
      nfeId: null,
      checkTpNF: true,
      nfceToImport: [],
      selectedNFCe: null,
      osToImport: null,
      selectedOS: null,
      printDuplicata: false,
      contasBancarias: [],
      teclasEnum: TECLAS,
    };
  },
  mixins: [
    validationMixin,
    FormatMixin,
    SistemaMixin,
    ValidacaoMixin,
    PagamentosMixin,
    InstallmentsMixin,
  ],
  components: {
    Natureza,
    Cliente,
    Produto,
    Transportador,
    Faturamento,
    Impostos,
    Intermediador,
    CheckBox,
    VueSelect,
  },
  watch: {
    total(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.valorTotal = newValue;
      }
    },
    checkTpNF(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.store.tpNF = newValue ? 1 : 0;
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });

    if (this.$route?.params?.nfeData) {
      this.id = this.$route.params.nfeData.nfeId;
      if (this.$route.params.nfeData.tpNF) {
        this.checkTpNF = true;
      }

      if (
        !this.$route.params.nfeData.tpNF ||
        this.$route.params.nfeData.tpNF == 0
      ) {
        this.checkTpNF = false;
      }
      this.store.tpNF = this.checkTpNF ? 1 : 0;
    }
    this.getDataInit();

    this.store.currentTab = 0;

    // Atalhos de teclado globais da NFe (F1/F2/F4/F5).
    this.__onNfeKey = (e) => this._handleNfeKey(e);
    window.addEventListener("keydown", this.__onNfeKey, { capture: true });

    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
    }
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.__onNfeKey, { capture: true });
  },
  methods: {
    ...mapActions(["setLoading"]),
    onSearchOS(search, loading) {
      loading(true);
      this.searchOS(loading, search, this);
    },

    // Captura, do FaturamentoTab atual, os pagamentos já existentes e o saldo pendente
    // ANTES de mexer em formProduto. Usado para aplicar as regras:
    //  - se há saldo pendente → não traz pagamento do import;
    //  - se já existe à vista → soma com o à vista do import.
    _capturarEstadoPagamentoNFe() {
      const fat = this.$refs.faturamento;
      const pagamentosAtuais = Array.isArray(fat?.pagamentosRealizados)
        ? [...fat.pagamentosRealizados]
        : [];
      const totalAtual = parseFloat(this.store?.formImpostos?.totalNFE) || 0;
      const valorPagoAtual = pagamentosAtuais.reduce(
        (acc, p) => acc + (parseFloat(p?.valor) || 0),
        0
      );
      const temProduto =
        Array.isArray(this.store?.formProduto?.produtos) &&
        this.store.formProduto.produtos.length > 0;
      // "Sem pagamento aplicado" = tem produto mas saldo pendente > 0 (subtotal não zerado).
      const temProdutoSemPagamento =
        temProduto && totalAtual - valorPagoAtual > 0.01;
      return { pagamentosAtuais, temProdutoSemPagamento };
    },

    // Converte um pagamento (formato pagamentosRealizados/form.pagamentos) para o
    // formato esperado por resolvePaymentsToImport (paymentModeCollection).
    _pagamentoNFeToRaw(p) {
      const desc = p?.forma_pagamento?.descricao ?? p?.descricao ?? "";
      const value = parseFloat(p?.valor ?? p?.value) || 0;
      return {
        id: p?.forma_pagamento?.id ?? p?.id ?? null,
        descricao: desc,
        id_meio_pagamento:
          p?.forma_pagamento?.id_meio_pagamento ?? p?.id_meio_pagamento ?? null,
        vezes: p?.forma_pagamento?.vezes ?? p?.vezes ?? 1,
        requer_entrada:
          p?.forma_pagamento?.requer_entrada ?? p?.requer_entrada ?? false,
        value,
        range: p?.range ?? [{ value, date: p?.vencimento ?? null }],
      };
    },

    // Constrói um formFaturamento (mesmo shape que extractDataFromImport gera)
    // a partir de uma lista resolvida de pagamentos.
    _buildFormFaturamentoFromResolved(resolved, observation) {
      if (!resolved || resolved.length === 0) return null;
      return {
        forma_pagamento: {
          id: resolved[0].id,
          descricao: resolved[0].descricao,
          id_meio_pagamento: resolved[0].id_meio_pagamento,
          vezes: resolved[0].vezes ?? 1,
          requer_entrada: resolved[0].requer_entrada ?? false,
          value: parseFloat(resolved[0].value) || 0,
        },
        pagamentos: resolved.map((p) => ({
          forma_pagamento: {
            id: p.id,
            descricao: p.descricao,
            id_meio_pagamento: p.id_meio_pagamento,
            vezes: p.vezes ?? 1,
            requer_entrada: p.requer_entrada ?? false,
            value: parseFloat(p.value) || 0,
          },
          informacoes_adicionais: observation ?? "",
          range: p.range ?? [],
          valor: parseFloat(p.value) || 0,
          vencimento: p.range?.[0]?.date ?? null,
        })),
      };
    },

    // Aplica pagamento importado na NFe, seguindo as regras:
    //  - se já havia saldo pendente antes deste import → não traz pagamento;
    //  - se há pagamento existente, tenta consolidar com o novo (todos à vista → soma).
    //    Se a consolidação falhar (tipos misturados) → não adiciona o novo (mantém o que já está).
    //  - se ainda assim resta payload válido, chama preencherPagamentosImportados().
    _aplicarPagamentoImportadoNFe(
      faturamentoNovo,
      estadoAnterior,
      observation
    ) {
      if (!faturamentoNovo) return;
      if (estadoAnterior?.temProdutoSemPagamento) return;

      const existentesRaw = (estadoAnterior?.pagamentosAtuais ?? []).map((p) =>
        this._pagamentoNFeToRaw(p)
      );

      // Se não há pagamento existente, aplica direto o que veio do import.
      if (existentesRaw.length === 0) {
        this.$refs.faturamento?.preencherPagamentosImportados(faturamentoNovo);
        return;
      }

      const novosRaw = (faturamentoNovo.pagamentos ?? []).map((p) =>
        this._pagamentoNFeToRaw(p)
      );

      // Tenta consolidar: regras "todos à vista → soma em 1" sobre o conjunto.
      const merged = this.resolvePaymentsToImport(
        [...existentesRaw, ...novosRaw],
        2
      );
      if (!merged) {
        // Misturou tipos diferentes (ex.: existing à vista + novo à prazo).
        // Não adiciona o novo: re-aplica apenas o existente para sobreviver ao
        // resetPayment() que o watcher de produtos disparou.
        const restored = this._buildFormFaturamentoFromResolved(
          existentesRaw,
          observation
        );
        if (restored) {
          this.$refs.faturamento?.preencherPagamentosImportados(restored);
        }
        return;
      }

      const novoFaturamento = this._buildFormFaturamentoFromResolved(
        merged,
        observation
      );
      if (novoFaturamento) {
        this.$refs.faturamento?.preencherPagamentosImportados(novoFaturamento);
      }
    },
    async importarPedido() {
      this.addLoadingToButton("importar_pedido");
      const pedidos = this.selectedPedidos.map(({ id_pedido }) => ({
        id_pedido,
      }));
      const selectedPedidosSnapshot = [...(this.selectedPedidos ?? [])];
      const pedidosCount = selectedPedidosSnapshot.length;
      try {
        const { data } = await this.$http.post("/pedido/importar", {
          pedidos,
        });
        const [formFaturamento, formProduto, formCliente, formTransportador] =
          this.extractDataFromImport(data, pedidosCount);
        this.store.transportadorImported = formTransportador;
        this.store.pedidos = pedidos;

        // Para 2+ pedidos: verifica snapshot para pegar à prazo que o API pode ter omitido
        const nfeSnapshotPayments =
          pedidosCount > 1
            ? selectedPedidosSnapshot.flatMap((p) => {
                try {
                  return JSON.parse(p.pagamentos ?? "[]");
                } catch {
                  return [];
                }
              })
            : [];
        const formFaturamentoVerified =
          formFaturamento !== null && nfeSnapshotPayments.length > 0
            ? this.resolvePaymentsToImport(
                nfeSnapshotPayments,
                pedidosCount
              ) !== null
              ? formFaturamento
              : null
            : formFaturamento;

        // Captura estado do pagamento ANTES de mexer em formProduto (watcher reseta payment).
        // Usado para regras: bloquear se havia saldo pendente; somar à vista existente + novo.
        const estadoAnterior = this._capturarEstadoPagamentoNFe();

        this.store.formProduto = formProduto;
        this.store.formFaturamento.informacoes_adicionais = data.observation;
        this.store.formImpostos.discount = data.discount;
        this.store.formImpostos.freightPrice = data.freightPrice;
        this.store.formNatureza.vendedor = data?.vendedor;

        if (this.store.cfop) {
          const produtosWithCFOPAplied = this.store.formProduto.produtos.map(
            (produto) => ({
              ...produto,
              product: {
                ...produto.product,
                cfop: this.store.cfop,
              },
            })
          );
          this.store.formProduto.produtos = produtosWithCFOPAplied;
        }
        if (formCliente) this.store.formCliente = formCliente;
        this.$toast.success("Pedido(s) importado(s) com sucesso!");
        this.$bvModal.hide("importarPedido");
        this.removeLoadingToButton("importar_pedido");
        this.selectedPedidos = null;
        try {
          const formImpostosAntes = { ...this.store.formImpostos };
          await this.calcImposto();
          const totalNFEAtualizado = this.store.formImpostos.totalNFE;
          this.store.formImpostos = {
            ...formImpostosAntes,
            totalNFE: totalNFEAtualizado,
          };
        } catch {
          // ignored
        }

        // Usa formFaturamento verificado (snapshot garante que à prazo não passa) ou
        // fallback que aplica as regras sobre os dados dos pedidos selecionados.
        const faturamentoParaAplicar =
          formFaturamentoVerified ??
          (() => {
            const rawPayments = selectedPedidosSnapshot.flatMap((pedido) => {
              try {
                return JSON.parse(pedido.pagamentos ?? "[]");
              } catch {
                return [];
              }
            });
            const resolved = this.resolvePaymentsToImport(
              rawPayments,
              pedidosCount
            );
            if (!resolved) return null;
            return {
              pagamentos: resolved.map((p) => ({
                forma_pagamento: {
                  id: p.id,
                  descricao: p.descricao,
                  id_meio_pagamento: p.id_meio_pagamento,
                  vezes: p.vezes ?? 1,
                  requer_entrada: p.requer_entrada ?? false,
                  value: parseFloat(p.value) || 0,
                },
                informacoes_adicionais: data.observation ?? "",
                range: p.range ?? [],
                valor: parseFloat(p.value) || 0,
                vencimento: p.range?.[0]?.date ?? null,
              })),
            };
          })();

        await this.$nextTick();
        // Pedido único: sempre aplica, ignora bloqueio de sessão
        const podePreencher =
          !this.pagamentoImportacaoBloqueado || pedidosCount <= 1;
        if (podePreencher && faturamentoParaAplicar) {
          this._aplicarPagamentoImportadoNFe(
            faturamentoParaAplicar,
            estadoAnterior,
            data.observation
          );
        } else if (
          !this.pagamentoImportacaoBloqueado &&
          !faturamentoParaAplicar &&
          pedidosCount > 1
        ) {
          // 2+ pedidos com pagamento não-à-vista: bloqueia sessão
          const hasActualPayments =
            this.hasImportablePayments(nfeSnapshotPayments);
          if (hasActualPayments) {
            this.pagamentoImportacaoBloqueado = true;
            this.$refs.faturamento?.resetPayment();
          }
        }
      } catch (error) {
        this.$toast.error("Erro ao importar pedido!");
        this.$bvModal.hide("importarPedido");
        this.removeLoadingToButton("importar_pedido");
      }
    },
    async buscarOrcamentos() {
      this.setLoading(true);
      try {
        const response = await this.$http.post(
          "/orcamento/orcamentos-autorizados"
        );
        this.orcamentosToImport = response.data.sort((a, b) => {
          if (a.id_orcamento < b.id_orcamento) return -1;
          if (a.id_orcamento > b.id_orcamento) return 1;
          return 0;
        });
        this.$bvModal.show("importarOrcamento");
      } catch (error) {
        this.$toast.error("Erro ao buscar orçamentos.");
      }
      this.setLoading(false);
    },
    async buscarPedidos() {
      this.setLoading(true);
      try {
        const response = await this.$http.post("/pedido/pedidos-autorizados");
        this.pedidosToImport = response.data.sort((a, b) => {
          if (a.id_pedido < b.id_pedido) return -1;
          if (a.id_pedido > b.id_pedido) return 1;
          return 0;
        });
        this.$bvModal.show("importarPedido");
      } catch (error) {
        this.$toast.error("Erro ao buscar pedidos.");
      }
      this.setLoading(false);
    },
    async buscarOS() {
      this.setLoading(true);
      try {
        const responseOS = await this.$http.post(
          "/ordemservico/os-autorizadas"
        );
        this.osToImport = responseOS.data.sort((a, b) => {
          if (a.id_ordem_servico < b.id_ordem_servico) return -1;
          if (a.id_ordem_servico > b.id_ordem_servico) return 1;
          return 0;
        });
        this.$bvModal.show("importarOS");
      } catch (error) {
        this.$toast.error("Erro ao buscar OS.");
      }
      this.setLoading(false);
    },
    searchOS: _.debounce(async (loading, search, vm) => {
      vm.osToImport = [];
      await vm.$nextTick();
      if (!search) {
        loading(false);
        return;
      }
      const response = await vm.$http.post("/ordemservico/os-autorizadas", {
        numero: search,
      });
      vm.osToImport = _.cloneDeep(response.data);
      loading(false);
    }, 500),
    onSearchOrcamento(search, loading) {
      loading(true);
      this.searchOrcamento(loading, search, this);
    },
    searchOrcamento: _.debounce(async (loading, search, vm) => {
      vm.orcamentosToImport = [];
      await vm.$nextTick();
      if (!search) {
        loading(false);
        return;
      }
      const response = await vm.$http.post(
        "/orcamento/orcamentos-autorizados",
        {
          numero: search,
        }
      );
      vm.orcamentosToImport = _.cloneDeep(response.data);
      loading(false);
    }, 500),
    onSearchPedido(search, loading) {
      loading(true);
      this.searchPedido(loading, search, this);
    },
    searchPedido: _.debounce(async (loading, search, vm) => {
      vm.pedidosToImport = [];
      await vm.$nextTick();
      if (!search) {
        loading(false);
        return;
      }
      const response = await vm.$http.post("/pedido/pedidos-autorizados", {
        numero: search,
      });
      vm.pedidosToImport = _.cloneDeep(response.data);
      loading(false);
    }, 500),
    onSearchNFCe(search, loading) {
      loading(true);
      this.searchNFCe(loading, search, this);
    },
    searchNFCe: _.debounce(async (loading, search, vm) => {
      vm.nfceToImport = [];
      await vm.$nextTick();
      if (isNaN(parseInt(search))) {
        loading(false);
        return;
      }
      const response = await vm.$http.post("/nfe/busca-nfce", {
        numero: parseInt(search),
      });
      vm.nfceToImport = _.cloneDeep(response.data);
      loading(false);
    }, 1000),
    async getDataInit() {
      this.getPagamentos();
      if (this.$route?.params?.nfeData?.nfeId) {
        this.setLoading(true);
      }
      try {
        const contasBancarias = await this.getBancosByEmpresa();
        this.contasBancarias = Array.isArray(contasBancarias)
          ? contasBancarias
          : [];
      } catch (error) {
        this.contasBancarias = [];
      }
    },
    async importarOS() {
      this.store.isImporting = true;
      this.addLoadingToButton("importar_os");
      try {
        const os = this.selectedOS.map(({ id_ordem_servico }) => ({
          id_ordem_servico,
        }));
        const selectedOSSnapshot = [...(this.selectedOS ?? [])];
        const osPedidosCount = os.length;
        const response = await this.$http.post("/nfe/importar-os", {
          os,
        });

        this.store.os = os;
        const [formFaturamento, formProduto, formCliente] =
          this.extractDataFromImport(response.data, osPedidosCount);

        // Captura estado do pagamento ANTES de mexer em formProduto (watcher reseta payment).
        const estadoAnterior = this._capturarEstadoPagamentoNFe();

        this.store.formProduto = formProduto;
        this.store.formFaturamento.informacoes_adicionais =
          response.data.observation;
        this.store.formImpostos.discount = response.data.discount;

        if (this.store.cfop) {
          const produtosWithCFOPAplied = this.store.formProduto.produtos.map(
            (produto) => ({
              ...produto,
              product: {
                ...produto.product,
                cfop: this.store.cfop,
              },
            })
          );
          this.store.formProduto.produtos = produtosWithCFOPAplied;
        }
        if (formCliente) this.store.formCliente = formCliente;
        this.selectedOS = null;
        this.$toast.success("OS(s) importada(s) com sucesso!");
        try {
          const formImpostosAntes = { ...this.store.formImpostos };
          await this.calcImposto();
          const totalNFEAtualizado = this.store.formImpostos.totalNFE;
          this.store.formImpostos = {
            ...formImpostosAntes,
            totalNFE: totalNFEAtualizado,
          };
        } catch {
          // ignored
        }
        // Fallback via snapshot quando o API filtra pagamentos não-à-vista
        const faturamentoOSAplicar =
          formFaturamento ??
          (() => {
            const rawPayments = selectedOSSnapshot.flatMap((o) => {
              try {
                return JSON.parse(o.pagamentos ?? "[]");
              } catch {
                return [];
              }
            });
            const resolved = this.resolvePaymentsToImport(
              rawPayments,
              osPedidosCount
            );
            if (!resolved) return null;
            return {
              pagamentos: resolved.map((p) => ({
                forma_pagamento: {
                  id: p.id,
                  descricao: p.descricao,
                  id_meio_pagamento: p.id_meio_pagamento,
                  vezes: p.vezes ?? 1,
                  requer_entrada: p.requer_entrada ?? false,
                  value: parseFloat(p.value) || 0,
                },
                informacoes_adicionais: response.data?.observation ?? "",
                range: p.range ?? [],
                valor: parseFloat(p.value) || 0,
                vencimento: p.range?.[0]?.date ?? null,
              })),
            };
          })();

        await this.$nextTick();
        const podaPreencherOs =
          !this.pagamentoImportacaoBloqueado || osPedidosCount <= 1;
        if (podaPreencherOs && faturamentoOSAplicar) {
          this._aplicarPagamentoImportadoNFe(
            faturamentoOSAplicar,
            estadoAnterior,
            response.data?.observation
          );
        } else if (
          !this.pagamentoImportacaoBloqueado &&
          !faturamentoOSAplicar &&
          osPedidosCount > 1
        ) {
          const snapshotOS = selectedOSSnapshot.flatMap((o) => {
            try {
              return JSON.parse(o.pagamentos ?? "[]");
            } catch {
              return [];
            }
          });
          const hasActualOsPayments = this.hasImportablePayments(snapshotOS);
          if (hasActualOsPayments) {
            this.pagamentoImportacaoBloqueado = true;
            this.$refs.faturamento?.resetPayment();
          }
        }
      } catch (error) {
        this.$toast.error("Erro ao importar OS!");
      } finally {
        this.store.isImporting = false;
      }
      this.removeLoadingToButton("importar_os");
      this.$bvModal.hide("importarOS");
    },
    async importarOrcamento() {
      this.store.isImporting = true;
      this.addLoadingToButton("importar_orcamento");
      try {
        const orcamentos = this.selectedOcamentos.map(({ id_orcamento }) => ({
          id_orcamento,
        }));
        const selectedOrcamentosSnapshot = [...(this.selectedOcamentos ?? [])];
        const orcamentosPedidosCount = orcamentos.length;
        const response = await this.$http.post("/nfe/importar-orcamento", {
          orcamentos,
        });

        this.store.orcamentos = orcamentos;
        const [formFaturamento, formProduto, formCliente] =
          this.extractDataFromImport(response.data, orcamentosPedidosCount);

        // Captura estado do pagamento ANTES de mexer em formProduto (watcher reseta payment).
        const estadoAnterior = this._capturarEstadoPagamentoNFe();

        this.store.formProduto = formProduto;
        this.store.formFaturamento.informacoes_adicionais =
          response.data.observation;
        this.store.formImpostos.discount = response.data.discount;
        this.store.formImpostos.freightPrice = response.data.freightPrice;
        this.store.formNatureza.vendedor = response.data?.vendedor;
        this.store.formTransportador.pesoBruto = response.data?.pesoBruto;
        this.store.formTransportador.pesoLiquido = response.data?.pesoLiquido;

        if (this.store.cfop) {
          const produtosWithCFOPAplied = this.store.formProduto.produtos.map(
            (produto) => ({
              ...produto,
              product: {
                ...produto.product,
                cfop: this.store.cfop,
              },
            })
          );
          this.store.formProduto.produtos = produtosWithCFOPAplied;
        }
        if (formCliente) this.store.formCliente = formCliente;

        this.selectedOcamentos = null;
        this.$toast.success("Orçamento(s) importado(s) com sucesso!");
        try {
          const formImpostosAntes = { ...this.store.formImpostos };
          await this.calcImposto();
          const totalNFEAtualizado = this.store.formImpostos.totalNFE;
          this.store.formImpostos = {
            ...formImpostosAntes,
            totalNFE: totalNFEAtualizado,
          };
        } catch {
          // ignored
        }
        // Fallback via snapshot quando o API filtra pagamentos não-à-vista
        const faturamentoOrcAplicar =
          formFaturamento ??
          (() => {
            const rawPayments = selectedOrcamentosSnapshot.flatMap((orc) => {
              try {
                return JSON.parse(orc.pagamentos ?? "[]");
              } catch {
                return [];
              }
            });
            const resolved = this.resolvePaymentsToImport(
              rawPayments,
              orcamentosPedidosCount
            );
            if (!resolved) return null;
            return {
              pagamentos: resolved.map((p) => ({
                forma_pagamento: {
                  id: p.id,
                  descricao: p.descricao,
                  id_meio_pagamento: p.id_meio_pagamento,
                  vezes: p.vezes ?? 1,
                  requer_entrada: p.requer_entrada ?? false,
                  value: parseFloat(p.value) || 0,
                },
                informacoes_adicionais: response.data?.observation ?? "",
                range: p.range ?? [],
                valor: parseFloat(p.value) || 0,
                vencimento: p.range?.[0]?.date ?? null,
              })),
            };
          })();

        await this.$nextTick();
        const podePrerencherOrc =
          !this.pagamentoImportacaoBloqueado || orcamentosPedidosCount <= 1;
        if (podePrerencherOrc && faturamentoOrcAplicar) {
          this._aplicarPagamentoImportadoNFe(
            faturamentoOrcAplicar,
            estadoAnterior,
            response.data?.observation
          );
        } else if (
          !this.pagamentoImportacaoBloqueado &&
          !faturamentoOrcAplicar &&
          orcamentosPedidosCount > 1
        ) {
          const snapshotOrc = selectedOrcamentosSnapshot.flatMap((orc) => {
            try {
              return JSON.parse(orc.pagamentos ?? "[]");
            } catch {
              return [];
            }
          });
          const hasActualOrcPayments = this.hasImportablePayments(snapshotOrc);
          if (hasActualOrcPayments) {
            this.pagamentoImportacaoBloqueado = true;
            this.$refs.faturamento?.resetPayment();
          }
        }
      } catch (error) {
        this.$toast.error("Erro ao importar orçamento!");
      } finally {
        this.store.isImporting = false;
      }
      this.removeLoadingToButton("importar_orcamento");
      this.$bvModal.hide("importarOrcamento");
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    async calcImposto() {
      this.dataSendToApi = this.formatDataToSendToApi(
        this.store.formNatureza,
        this.store.formProduto,
        this.store.formCliente,
        this.store.formFaturamento.pagamentos.length === 0
          ? null
          : this.store.formFaturamento,
        this.store.formImpostos
      );
      const { dados } = await this.getTotaisNfe(this.dataSendToApi);
      this.store.formImpostos = {
        ...this.store.formImpostos,
        ...dados.total,
      };

      this.produtos = dados.productOfTradeCollection;
    },
    async importarNFce() {
      this.store.isImporting = true;
      this.addLoadingToButton("importar_nfce");
      try {
        const nfces = this.selectedNFCe.map(({ id }) => ({
          id,
        }));
        const { data: nfceData } = await this.$http.post("/nfe/importar-nfce", {
          nfces,
        });
        const [formFaturamento, formProduto, formCliente] =
          this.extractDataFromImport(nfceData, null);
        if (formFaturamento) this.store.formFaturamento = formFaturamento;
        this.store.formProduto = formProduto;

        if (this.store.cfop) {
          const produtosWithCFOPAplied = this.store.formProduto.produtos.map(
            (produto) => ({
              ...produto,
              product: {
                ...produto.product,
                cfop: this.store.cfop,
              },
            })
          );
          this.store.formProduto.produtos = produtosWithCFOPAplied;
        }

        if (formCliente) this.store.formCliente = formCliente;
        this.store.refNFCe = nfceData.refNFCe;
        this.store.formImpostos.discount = nfceData.discount ?? 0;
        this.store.formImpostos.freightPrice = nfceData.freightPrice ?? 0;

        try {
          const formImpostosAntes = { ...this.store.formImpostos };
          await this.calcImposto();
          const totalNFEAtualizado = this.store.formImpostos.totalNFE;
          this.store.formImpostos = {
            ...formImpostosAntes,
            totalNFE: totalNFEAtualizado,
          };
        } catch {
          // ignored
        }

        this.$toast.success("NFce Importada com sucesso!");
        this.selectedNFCe = null;
      } catch (error) {
        this.$toast.error("Erro ao importar NFce!");
        this.selectedNFCe = null;
      } finally {
        this.store.isImporting = false;
      }
      this.$bvModal.hide("importarNfce");
      this.removeLoadingToButton("importar_nfce");
      this.selectedNFCe = null;
    },
    async transmitirNFe() {
      const submitButton = this.$refs["transmitir_nfe"];

      this.$toast.info("Criando nfe...");

      const data = {
        ...this.formatDataToSendToApi(
          this.store.formNatureza,
          this.store.formProduto,
          this.store.formCliente,
          this.store.formFaturamento,
          this.store.formImpostos,
          this.store.formIntermediador.usuario === null
            ? undefined
            : this.store.formIntermediador,
          this.store.formTransportador,
          this.store.formRural
        ),
        refNFCe: this.store.refNFCe,
        ...(this.store.pedidos &&
          this.store.pedidos.length > 0 && { pedidos: this.store.pedidos }),
        ...(this.store.os && this.store.os.length > 0 && { os: this.store.os }),
        ...(this.store.orcamentos &&
          this.store.orcamentos.length > 0 && {
            orcamentos: this.store.orcamentos,
          }),
      };
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      submitButton.setAttribute("disabled", "");
      try {
        if (this.nfeId) {
          await this.$http.post("/nfe/update-nfe", {
            dados: {
              ...data,
              id: this.nfeId,
              tpNF: this.store.tpNF,
            },
          });
        } else {
          const id = await this.criarNfe(data, this.store.tpNF);
          this.nfeId = id;
        }
        if (!this.nfeId) {
          this.$toast.error("Erro ao criar NFe!");
          this.$toast.error("Erro ao transmitir Nfe");
          this.$toast.error(
            "Faça as correções necessárias e transmita novamente"
          );
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
          submitButton.removeAttribute("disabled", "");
          return;
        }

        this.$toast.success("NFe criada com sucesso!");
        this.$toast.info("Transmitindo...");

        const response = await this.transmitirNfeApi(
          this.nfeId,
          this.xmlToEmail,
          this.printDanfe,
          this.generateBoleto
        );

        if (!response) {
          this.$toast.error("Erro ao transmitir Nfe");
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
          submitButton.removeAttribute("disabled", "");
          return;
        }

        this.$toast.success("NFe transmitida com sucesso!");

        if (this.printDanfe) {
          this.$toast.info("Gerando pdf...");
          const { data } = await this.gerarPdf(this.nfeId, this.printDuplicata);
          this.pdfUrl = data["danfe-url"];

          this.$toast.success("Pdf gerado com sucesso!");
          window.open(this.pdfUrl, "_blank");

          if (data["duplicata"]) {
            window.open(data["duplicata"], "_blank");
          }
        }

        if (response.data.boletos) {
          response.data.boletos.forEach(function (boleto) {
            window.open(boleto.url_boleto, "_blank");
          });
          this.$toast.success("Boleto gerado com sucesso!");
        }

        this.store.refNFCe = null;
        this.store.devolucaoCreditoItens = [];
        this.$router.push({ name: "nfe" });
      } catch (error) {
        this.$toast.error("ERRO!", JSON.stringify(error, 2, 0));
      }

      submitButton.classList.remove(
        "spinner",
        "spinner-light",
        "spinner-right"
      );
      submitButton.removeAttribute("disabled", "");
      this.store.dataFetched = false;
    },

    async salvarNFe() {
      this.addLoadingToButton("submit_nova_nfe");
      if (Object.keys(this.$route.params).length !== 0 && this.store.isUpdate) {
        const { nfeId: id } = this.$route.params.nfeData;
        const data = this.formatDataToSendToApi(
          this.store.formNatureza,
          this.store.formProduto,
          this.store.formCliente,
          this.store.formFaturamento,
          this.store.formImpostos,
          this.store.formIntermediador.usuario === null
            ? undefined
            : this.store.formIntermediador,
          this.store.formTransportador,
          this.store.formRural
        );
        try {
          await this.$http.post("/nfe/update-nfe", {
            dados: {
              ...data,
              id,
              tpNF: this.store.tpNF,
            },
          });
          this.$toast.success("NFe editada com sucesso!");
          this.store.refNFCe = null;
          this.store.devolucaoCreditoItens = [];
          this.$router.push({ name: "nfe" });
        } catch (error) {
          this.$toast.error("Verifique as informações ao salvar NFe");
        }
      } else {
        try {
          const data = {
            ...this.formatDataToSendToApi(
              this.store.formNatureza,
              this.store.formProduto,
              this.store.formCliente,
              this.store.formFaturamento,
              this.store.formImpostos,
              this.store.formIntermediador.usuario === null
                ? undefined
                : this.store.formIntermediador,
              this.store.formTransportador,
              this.store.formRural
            ),
            refNFCe: this.store.refNFCe,
          };
          if (this.nfeId) {
            await this.$http.post("/nfe/update-nfe", {
              dados: {
                ...data,
                id: this.nfeId,
                tpNF: this.store.tpNF,
              },
            });
          } else {
            const id = await this.criarNfe(data, this.store.tpNF);
            this.nfeId = id;
          }
          this.store.refNFCe = null;
          this.store.devolucaoCreditoItens = [];
          this.$toast.success("NFe salva com sucesso!");
          this.$router.push({ name: "nfe" });
        } catch (error) {
          this.$toast.error("Verifique as informações ao salvar NFe");
        }
        return;
      }
      this.removeLoadingToButton("submit_nova_nfe");
      this.store.dataFetched = false;
    },
    async salvarPreviaNFe() {
      this.addLoadingToButton("submit_danfe");
      if (Object.keys(this.$route.params).length !== 0 && this.store.isUpdate) {
        const { nfeId: id } = this.$route.params.nfeData;
        const data = this.formatDataToSendToApi(
          this.store.formNatureza,
          this.store.formProduto,
          this.store.formCliente,
          this.store.formFaturamento,
          this.store.formImpostos,
          this.store.formIntermediador.usuario === null
            ? undefined
            : this.store.formIntermediador,
          this.store.formTransportador,
          this.store.formRural
        );
        try {
          await this.$http.post("/nfe/update-nfe", {
            dados: {
              ...data,
              id,
              tpNF: this.store.tpNF,
            },
          });
          this.$toast.success("NFe editada com sucesso!");
          this.removeLoadingToButton("submit_danfe");
          this.imprimirPDF(id);
          this.store.refNFCe = null;
          this.store.devolucaoCreditoItens = [];
          this.removeLoadingToButton("submit_danfe");
        } catch (error) {
          this.$toast.error("Verifique as informações da NFe!");
          this.removeLoadingToButton("submit_danfe");
        }
      } else {
        try {
          const data = {
            ...this.formatDataToSendToApi(
              this.store.formNatureza,
              this.store.formProduto,
              this.store.formCliente,
              this.store.formFaturamento,
              this.store.formImpostos,
              this.store.formIntermediador.usuario === null
                ? undefined
                : this.store.formIntermediador,
              this.store.formTransportador,
              this.store.formRural
            ),
            refNFCe: this.store.refNFCe,
          };
          if (this.nfeId || this.store.isUpdate) {
            await this.$http.post("/nfe/update-nfe", {
              dados: {
                ...data,
                id: this.nfeId,
                tpNF: this.store.tpNF,
              },
            });
            this.imprimirPDF(this.nfeId);
            this.removeLoadingToButton("submit_danfe");
          } else {
            const id = await this.criarNfe(data, this.store.tpNF);
            this.nfeId = id;

            this.imprimirPDF(this.nfeId);
          }
          this.store.refNFCe = null;
          this.store.devolucaoCreditoItens = [];
          this.$toast.success("NFe salva com sucesso!");
          this.removeLoadingToButton("submit_danfe");
        } catch (error) {
          this.$toast.error("Erro ao salvar NFe");
          this.removeLoadingToButton("submit_danfe");
        }
        return;
      }
      this.removeLoadingToButton("submit_danfe");
      this.store.dataFetched = false;
    },
    imprimirPDF(id) {
      swal({
        title: "Deseja visualizar a prévia da NFe?",
        text: "Este documento ainda não tem validade fiscal, somente após ser autorizado!",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/nfe/print-nfe", {
            id: id,
          })
          .then((result) => {
            const resultData = result["data"]["danfe-url"];
            if (resultData) {
              window.open(result["data"]["danfe-url"], "_blank");
            }
            swal.stopLoading();
            swal.close();
            this.$toast.success("PDF gerado com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    // Trata os atalhos globais da NFe: F1 (cancelar), F2 (salvar),
    // F4 (visualizar pré-DANFE) e F5 (próxima aba / transmitir).
    // Usa e.key (padrao moderno) para nao depender do enum TECLAS, evitando
    // bugs caso alguma tecla de funcao esteja ausente do enum.
    _handleNfeKey(e) {
      if (e.repeat) return;

      // F5 eh bloqueado preventivamente em qualquer contexto para evitar o
      // refresh acidental do navegador (mesmo comportamento do PDV).
      if (e.key === "F5") {
        e.preventDefault();
        e.stopPropagation();
      }

      // Com o modal de transmissao aberto, o F5 confirma a transmissao
      // (aciona o botao "Transmitir"), completando o fluxo por teclado.
      if (e.key === "F5" && this._modalTransmitirAberto()) {
        this.transmitirNFe();
        return;
      }

      // Nao dispara os demais atalhos enquanto ha algum modal aberto.
      if (this._algumModalAberto()) return;

      switch (e.key) {
        case "F1":
          e.preventDefault();
          this.confirmCancel("nfe");
          break;
        case "F2":
          if (this.canSaveNfe) {
            e.preventDefault();
            this.salvarNFe();
          }
          break;
        case "F3":
          // Visualizar Pre-DANFE (disponivel quando ja pode salvar).
          if (this.canSaveNfe) {
            e.preventDefault();
            this.salvarPreviaNFe();
          }
          break;
        case "F4":
          // F4 = aba anterior.
          e.preventDefault();
          this.handlePrevious();
          break;
        case "F5":
          // F5 = proxima aba; na ultima aba abre o modal de transmissao.
          if (this.store.currentTab < 6) {
            this.handleNext();
          } else {
            this.$bvModal.show("modalTransmitirNfe");
          }
          break;
      }
    },
    // Verifica se ha algum modal do bootstrap-vue aberto (body.modal-open).
    _algumModalAberto() {
      return Boolean(
        document.body && document.body.classList.contains("modal-open")
      );
    },
    // Verifica se o modal de transmissao (#modalTransmitirNfe) esta visivel.
    _modalTransmitirAberto() {
      const modal = document.getElementById("modalTransmitirNfe");
      return Boolean(modal && modal.classList.contains("show"));
    },
    handleNext() {
      if (this.store.formNatureza.cfop !== "5929") {
        if (!this.isDevolution) {
          if (this.store.currentTab === 4) {
            if (
              this.store.formImpostos.totalNFE &&
              this.store.formFaturamento
            ) {
              const total = this.store.formFaturamento.pagamentos.reduce(
                (soma, item) => this.round(soma + item.valor, 2),
                0
              );

              if (
                this.round(total, 2) <
                this.round(this.store.formImpostos.totalNFE, 2)
              ) {
                this.$toast.warning(
                  "Para avançar verifique o valor total dos pagamentos!"
                );
                return;
              }
            }
          }
        }
      }

      if (this.store.currentTab === 6) return;
      this.store.currentTab++;
    },
    handlePrevious() {
      if (this.store.currentTab === 0) return;
      this.store.currentTab--;
    },
    checkNutsDigital() {
      if (!this.canGenerateBoleto) {
        return "Configure uma integração de boleto nas contas bancárias para gerar boletos.";
      }

      return "Os boletos serão enviados para o e-mail do cliente, conforme está lançado na NFe";
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "nutsDigital",
    ]),
    ...mapState(["loading"]),
    temSicoobApi() {
      return this.contasBancarias?.some(isSicoobApiAtiva) ?? false;
    },
    canGenerateBoleto() {
      return Boolean(this.nutsDigital || this.temSicoobApi);
    },
    isLoading() {
      return this.loading.loading;
    },
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    toolbarDisplay() {
      return true;
    },
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
    displaySubheaderOnDashboard() {
      return this.$route.name !== "dashboard";
    },
    canSaveNfe() {
      return this.store.currentTab === 6 || this.store.isUpdate;
    },
    isDevolution() {
      return (
        store.formNatureza.finalidade?.descricao === "Devolução de mercadoria"
      );
    },
  },
  created() {
    this.store.isUpdate = false;
    if (Object.keys(this.$route.params).length !== 0) {
      const { nfeId } = this.$route.params.nfeData;
      this.store.isUpdate = true;
      this.nfeId = nfeId;
      if (!nfeId) {
        this.store.isUpdate = false;
      }
    }
    this.store.tpNF = 1;
  },
};
</script>

<style>
.vs-pedido-clean .vs__selected {
  display: none;
}

@media (max-width: 991.98px) {
  .container {
    padding: 0;
  }

  .card-body-container {
    padding: 0rem;
  }

  .card-body {
    padding: 1rem;
  }
}

.action-buttons {
  display: flex;
}

.cardHeader {
  display: flex;
  max-width: 11rem;
  justify-content: center;
  background-color: white;
  margin-bottom: 5px;
  border-radius: 14px;
  padding: 0.5rem;
  margin-left: auto;
}

.busca-produto .vs__search {
  font-weight: 400;
  font-size: 1.45rem !important;
  margin-bottom: 0.5rem !important;
  line-height: 1.2 !important;
  text-transform: uppercase !important;
}

.busca-produto .vs__dropdown-toggle {
  border: 0px !important;
}

.busca-produto .vs__actions {
  display: none;
}

.busca-produto .vs__selected-options {
  max-width: 100%;
  flex-wrap: initial;
}

.busca-produto .vs__selected {
  text-align: left !important;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.busca-cliente .vs__search {
  font-size: 18px;
}

.busca-cliente .vs__dropdown-toggle {
  color: var(--primary-color);
  background-color: #fff;
  border: 2px solid #dedede;
  height: 40px;
}

.busca-cliente .vs--open .vs__dropdown-toggle {
  background-color: #fff;
  border: 2px solid var(--primary-color);
}

.busca-cliente .vs__actions {
  display: none;
}

.busca-cliente .vs__dropdown-option--highlight,
.vs__dropdown-menu li:hover,
.vs__dropdown-menu li:focus {
  background-color: var(--primary-color) 5e !important;
  color: var(--primary-color) !important;
}

.busca-cliente .vs__dropdown-menu {
  color: var(--primary-color) !important;
}

.busca-cliente .vs__selected-options {
  max-width: 100%;
  flex-wrap: initial;
}

.busca-cliente .vs__selected {
  text-align: left !important;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.remove-pgto {
  font-weight: bold;
  font-size: 18px;
  color: #4f4f4f;
}

.add-pgto {
  font-weight: bold;
  font-size: 22px;
  color: var(--primary-color);
  float: right;
}

.input-quantidade {
  font-size: 1.75rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  background: transparent;
  border: transparent;
  color: #fff;
  padding: 0px;
  margin-top: -10px;
  margin-bottom: 0px;
  text-align: right;
}

.input-quantidade:focus {
  box-shadow: 0 0 0 0;
  border: 0 none;
  outline: 0;
  border: 0px;
  background-color: transparent;
  color: #fff;
}

.card {
  border: 0;
}

h4 {
  color: #6d747c;
  /* font-weight: 900; */
}

.btn-finalizar-venda {
  background-color: #eee5ff !important;
  font-size: 1.25rem !important;
  text-align: center !important;
  cursor: pointer;
}

.card-total-right p,
.card-total-left p {
  color: #fff !important;
}

.card-header h5,
.card-header h3 {
  margin-bottom: 0rem;
}

.card-header .form-control {
  height: auto;
  margin-top: 0px;
}

.card-header .busca-produto {
  margin-top: 2px;
}

.card-titulo-itens .card-body-container {
  padding: 0px 0 !important;
}

.card-itens .table tr th {
  padding: 5px;
  font-size: 12px;
}

.card-itens .table tr td,
.card-total-right p,
.card-total-left p {
  font-size: 12px;
}

.tableItensCompra {
  max-height: 300px !important;
  height: calc(100vh - 395px) !important;
}

.card-total-left,
.card-total-right {
  height: 80px !important;
}

.btn.btn-secondary {
  color: var(--primary-color);
  background-color: #fff;
  border-color: #fff;
}
.vue-select .vs__selected {
  display: flex;
  flex-wrap: wrap; /* Permite os itens quebrarem para a próxima linha */
  gap: 0.4rem; /* Espaçamento entre os itens */
}

.vue-select .vs__selected-item {
  max-width: 100%; /* Evita quebra no texto longo */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; /* Trunca o texto se for muito longo */
}
.vue-select {
  max-width: 100%; /* Limita a largura do componente */
  overflow: hidden; /* Oculta excessos */
}

.vue-select .vs__selected {
  max-height: 80px; /* Define uma altura máxima */
  overflow-y: auto; /* Adiciona rolagem vertical se necessário */
}
</style>
